// Configuración SEO centralizada para @vueuse/head

export const defaultSEO = {
  title: 'OPTIMUZ - Sistema de Gestión de Imágenes Médicas',
  titleTemplate: '%s | OPTIMUZ',
  meta: [
    {
      name: 'description',
      content: 'OPTIMUZ MRIS - Sistema completo de gestión de imágenes médicas con almacenamiento en la nube, alta disponibilidad y múltiples roles de usuario.'
    },
    {
      name: 'keywords',
      content: 'OPTIMUZ, MRIS, imágenes médicas, DICOM, radiología, sistema médico, almacenamiento nube'
    },
    {
      name: 'author',
      content: 'OPTIMUZ Team'
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0'
    },
    {
      name: 'robots',
      content: 'index, follow'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:site_name',
      content: 'OPTIMUZ'
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      name: 'twitter:site',
      content: '@optimuz'
    }
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico'
    }
  ]
};

export const pageSEO = {
  home: {
    title: 'OPTIMUZ MRIS - Sistema de Gestión de Imágenes Médicas | Inicio',
    meta: [
      {
        name: 'description',
        content: 'OPTIMUZ MRIS ofrece soluciones completas para la gestión de imágenes médicas con almacenamiento en la nube, alta disponibilidad, dictado por voz y visor DICOM zero-footprint. Tecnología médica avanzada para hospitales y clínicas.'
      },
      {
        name: 'keywords',
        content: 'OPTIMUZ MRIS, imágenes médicas, DICOM, radiología, PACS, RIS, almacenamiento nube, dictado por voz, visor DICOM, sistema hospitalario, gestión médica'
      },
      {
        property: 'og:title',
        content: 'OPTIMUZ MRIS - Sistema de Gestión de Imágenes Médicas'
      },
      {
        property: 'og:description',
        content: 'Solución integral para la gestión de imágenes médicas con tecnología de vanguardia, almacenamiento seguro en la nube y herramientas avanzadas de diagnóstico.'
      },
      {
        property: 'og:image',
        content: '/images/HerOptimuz.png'
      },
      {
        property: 'og:url',
        content: 'https://optimuz.com'
      },
      {
        name: 'twitter:title',
        content: 'OPTIMUZ MRIS - Sistema de Gestión de Imágenes Médicas'
      },
      {
        name: 'twitter:description',
        content: 'Tecnología médica avanzada para la gestión eficiente de imágenes diagnósticas'
      },
      {
        name: 'twitter:image',
        content: '/images/HerOptimuz.png'
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://optimuz.com'
      }
    ]
  },
  
  productos: {
    title: 'Productos Médicos - OPTIMUZ MRIS',
    meta: [
      {
        name: 'description',
        content: 'Descubre nuestra gama completa de productos médicos: OPTIMUZ MRIS, MRIS ECG, MRIS DENTAL y soluciones de hardware especializado para centros médicos.'
      },
      {
        name: 'keywords',
        content: 'productos médicos, MRIS ECG, MRIS DENTAL, hardware médico, equipos radiología, monitores médicos'
      },
      {
        property: 'og:title',
        content: 'Productos Médicos - OPTIMUZ MRIS'
      },
      {
        property: 'og:description',
        content: 'Gama completa de productos médicos especializados para centros de salud y hospitales.'
      }
    ]
  }
};

// Función helper para generar metadatos estructurados
export function generateStructuredData(type, data) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data
  };
  
  return {
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(structuredData)
      }
    ]
  };
}

// Datos estructurados para la organización
export const organizationStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OPTIMUZ',
  description: 'Sistema de gestión de imágenes médicas con tecnología avanzada',
  url: 'https://optimuz.com',
  logo: 'https://optimuz.com/images/logo.png',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-XXX-XXX-XXXX',
    contactType: 'customer service'
  },
  sameAs: [
    'https://www.linkedin.com/company/optimuz',
    'https://twitter.com/optimuz'
  ]
};